import React, {useState} from 'react';
import {storage} from "../core/Firebase";
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import fileExtension from '../utils/file-extension';


const CoverImage = ({ id, register, error, onUploadComplete, type }) => {
    const [uploaded, setUploaded] = useState(0);

    const handleCoverUpload = (event) => {
        const image = event.target.files[0];

        if (!image) {
            alert('No images were uploaded.');
            return;
        }

        const extension = fileExtension(image.name);
        const storageRef = ref(storage, `${type}/${id}.${extension}`);
        const metadata = {
            contentType: 'image/png',
        };
        const uploadTask = uploadBytesResumable(storageRef, image, metadata);

        uploadTask.on(
            'state_changed',
            (snapshot) => {
                setUploaded((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            },
            (error) => console.log(error),
            async () => {
                const url = await getDownloadURL(uploadTask.snapshot.ref);
                console.log(url);
                onUploadComplete(url);
            }
        );
    };

    return (
        <label className="block">
            <span className="label-text text-xs font-semibold">Cover image</span>
            <input
                className="file-input file-input-bordered file-input-sm w-full mt-1"
                type="file"
                placeholder="Cover"
                onChange={handleCoverUpload}
            />
            {uploaded > 0 ? <span className="text-xs text-base-content/60">{uploaded}%</span> : null}
        </label>
    );
}

export default CoverImage;
